import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getTempMaterialOther as _getTempMaterialOther, getMaterialOther as _getMaterialOther } from '@/api/wxmp/wxmaterial';
var BenzAMRRecorder = require('benz-amr-recorder');
export default {
  name: "wxVoicePlayer",
  props: {
    objData: {
      type: Object
    },
    appId: {
      type: String
    }
  },
  data: function data() {
    return {
      outTime: false,
      mainLoading: false
    };
  },
  created: function created() {
    this.outTime = this.objData.type === '1' && parseInt(new Date().getTime() - new Date(this.objData.createTime).getTime()) >= 259200000;
  },
  mounted: function mounted() {},
  computed: {},
  methods: {
    amrPlay: function amrPlay(amr, val) {
      this.$set(val, 'amrPlaying', true);
      amr.play();
    },
    amrStop: function amrStop(amr, val) {
      this.$set(val, 'amrPlaying', false);
      amr.stop();
    },
    playVoice: function playVoice(val) {
      var _this = this;
      var amr = val.amr;
      if (amr == undefined) {
        if (val.type == '2') {
          this.getMaterialOther(val.repMediaId, val.repName).then(function (url) {
            _this.$set(val, 'repUrl', url);
            _this.handleAudio(val);
          });
        } else if (val.type == '1') {
          this.getTempMaterialOther(val.repMediaId, val.repName).then(function (url) {
            _this.$set(val, 'repUrl', url);
            _this.handleAudio(val);
          });
        }
      } else {
        if (amr.isPlaying()) {
          this.amrStop(amr, val);
        } else {
          this.amrPlay(amr, val);
        }
      }
    },
    getTempMaterialOther: function () {
      var _getTempMaterialOther2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(repMediaId, fileName) {
        var _this2 = this;
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.mainLoading = true;
              _context.next = 3;
              return _getTempMaterialOther({
                mediaId: repMediaId,
                fileName: fileName,
                appId: this.appId
              }).then(function (response) {
                _this2.mainLoading = false;
                url = window.URL.createObjectURL(new Blob([response.data]));
              }).catch(function () {
                _this2.mainLoading = false;
              });
            case 3:
              return _context.abrupt("return", url);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTempMaterialOther(_x, _x2) {
        return _getTempMaterialOther2.apply(this, arguments);
      }
      return getTempMaterialOther;
    }(),
    getMaterialOther: function () {
      var _getMaterialOther2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(repMediaId, fileName) {
        var _this3 = this;
        var url;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.mainLoading = true;
              _context2.next = 3;
              return _getMaterialOther({
                mediaId: repMediaId,
                fileName: fileName,
                appId: this.appId
              }).then(function (response) {
                _this3.mainLoading = false;
                url = window.URL.createObjectURL(new Blob([response.data]));
              }).catch(function () {
                _this3.mainLoading = false;
              });
            case 3:
              return _context2.abrupt("return", url);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getMaterialOther(_x3, _x4) {
        return _getMaterialOther2.apply(this, arguments);
      }
      return getMaterialOther;
    }(),
    handleAudio: function handleAudio(val) {
      this.$set(val, 'amr', new BenzAMRRecorder());
      var amr = val.amr;
      var that = this;
      amr.initWithUrl(val.repUrl).then(function () {
        that.amrPlay(amr, val);
        that.$set(val, 'amrDuration', amr.getDuration());
      });
      amr.onEnded(function () {
        that.$set(val, 'amrPlaying', false); //播放完了
      });
    }
  }
};